/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getThread = /* GraphQL */ `
  query GetThread($id: ID!) {
    getThread(id: $id) {
      id
      name
      messages {
        items {
          id
          threadId
          senderId
          content
          createdOn
          updatedOn
          owner
          __typename
        }
        nextToken
        __typename
      }
      userId
      lastMessageSentAt
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listThreads = /* GraphQL */ `
  query ListThreads(
    $filter: ModelThreadFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listThreads(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        messages {
          nextToken
          __typename
        }
        userId
        lastMessageSentAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMessage = /* GraphQL */ `
  query GetMessage($id: ID!) {
    getMessage(id: $id) {
      id
      threadId
      senderId
      content
      createdOn
      updatedOn
      owner
      __typename
    }
  }
`;
export const listMessages = /* GraphQL */ `
  query ListMessages(
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMessages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        threadId
        senderId
        content
        createdOn
        updatedOn
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const threadsByUserIdAndLastMessageSentAt = /* GraphQL */ `
  query ThreadsByUserIdAndLastMessageSentAt(
    $userId: String!
    $lastMessageSentAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelThreadFilterInput
    $limit: Int
    $nextToken: String
  ) {
    threadsByUserIdAndLastMessageSentAt(
      userId: $userId
      lastMessageSentAt: $lastMessageSentAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        messages {
          nextToken
          __typename
        }
        userId
        lastMessageSentAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const messagesByThreadIdAndCreatedOn = /* GraphQL */ `
  query MessagesByThreadIdAndCreatedOn(
    $threadId: ID!
    $createdOn: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messagesByThreadIdAndCreatedOn(
      threadId: $threadId
      createdOn: $createdOn
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        threadId
        senderId
        content
        createdOn
        updatedOn
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
